import i18n from '@/utils/i18n'
import PageAll from '@/components/PageAll'

const languages = i18n.messages[i18n.locale].router
  
export default [
    {
        path: '/device',
        name: 'device',
		subheader: languages.device.title,
        meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            permCode: "02",
            icon: "printer",
        },
        component: PageAll,
		children: [
			{
				path: '/device',
				name: 'device-list',
				component: resolve => require(['@/pages/device/index'], resolve),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					title: languages.device.title1,
					permCode: "0201",
				},
			}
		]
    },
]
  